import '@/sentry/sentryInit'
import '@/libraries/ensure_locale_loaded'
import LucaLogin from '@/authentication/LucaLogin'
import '@/libraries/fontawesome'
import { startPlausible } from '@/libraries/plausible'
import 'bootstrap'
import { Application } from '@hotwired/stimulus'
import FlashListController from '@/controllers/flash_list_controller'
import CustomerAnalyticsController from '@/controllers/customer_analytics_controller'
import UserEditPasswordController from '@/controllers/user/edit_password_controller'

startPlausible()

window.onload = function () {
  const lucaLogin = new LucaLogin()
  lucaLogin.listenToAuthChange()
}

// Register only controllers we need when logged out
let application = Application.start()
application.register('flash-list', FlashListController)
application.register('customer-analytics', CustomerAnalyticsController)
application.register('user--edit-password', UserEditPasswordController)
